import { $, jQuery } from './jquery';

import '../../dist/assets/vendor/slick-carousel/slick/slick.css';
import '../../dist/assets/vendor/dzsparallaxer/dzsparallaxer.css';
import '../../dist/assets/vendor/leaflet/dist/leaflet.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import HSUnfold from '../../dist/assets/vendor/hs-unfold/src/js/hs-unfold';
import HSCounter from '../../dist/assets/vendor/hs-counter/src/js/hs-counter';
import HSGoTo from '../../dist/assets/vendor/hs-go-to/src/js/hs-go-to';

import '../../dist/assets/vendor/appear/dist/appear.min.js';
import '../../dist/assets/vendor/dzsparallaxer/dzsparallaxer.js';
import '../../dist/assets/vendor/bootstrap/dist/js/bootstrap.min.js';

import '../../dist/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js';

import L from '../../dist/assets/vendor/leaflet/dist/leaflet.js';
import algoliasearch from 'algoliasearch/lite';

import { default as Nette } from '../../dist/js/netteForms.min.js';
window.Nette = Nette;
import '../components/nette.ajax.js/nette.ajax.js';

// Replace the browser's default HTML5 validation popup with a clearer visual
// cue: each invalid control gets Bootstrap's `is-invalid` class (red border +
// icon). The state is cleared as soon as the user starts fixing the field.
function enhanceFormValidation(form) {
    if (!(form instanceof HTMLFormElement) || form.dataset.validationEnhanced === '1') {
        return;
    }
    form.dataset.validationEnhanced = '1';
    form.noValidate = true;

    form.addEventListener('submit', function (event) {
        form.querySelectorAll('.is-invalid').forEach(function (el) {
            el.classList.remove('is-invalid');
        });

        if (form.checkValidity()) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        var firstInvalid = null;

        Array.prototype.slice.call(form.elements).forEach(function (el) {
            if (!el.willValidate || el.checkValidity()) {
                return;
            }
            if (!firstInvalid) {
                firstInvalid = el;
            }

            el.classList.add('is-invalid');

            var clear = function () {
                el.classList.remove('is-invalid');
                el.removeEventListener('input', clear);
                el.removeEventListener('change', clear);
            };
            el.addEventListener('input', clear);
            el.addEventListener('change', clear);
        });

        if (firstInvalid) {
            if (firstInvalid.focus) firstInvalid.focus();
            if (firstInvalid.scrollIntoView) {
                firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, true);
}

document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.forms).forEach(enhanceFormValidation);
});

$(function () {
    $.nette.init();

    // lazy loading of css background images
    var lazyBackgrounds = [].slice.call(document.querySelectorAll('[data-background-image]'));

    if ("IntersectionObserver" in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    entry.target.style.backgroundImage = `url(${entry.target.getAttribute('data-background-image')})`;
                    
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });

        lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    }
    else {
        $('[data-background-image]').each(function(i, el) {
            $(el).css('background-image', 'url(' + $(el).data('background-image') + ')');
        });
    }

    $('[data-change-locale]').on('click', function() {
        window.location.href = $(this).data('change-locale');
    });

    $('a[data-ping]').each(function(i, el) {
        el.addEventListener("click", function(e) {
            fetch(el.getAttribute('data-ping'), { method: 'post' }).then(() => {
                window.location.href = el.getAttribute('href');
            });
            e.preventDefault();
        });
    });

    $('input[autocomplete-type]').each(function(i, el) {
        initAutocomplete(el, el.getAttribute('autocomplete-type'));
    });

    if ($('#ai-news-summary').length) {
        $('#ai-news-summary').show();

        $.nette.ajax({
            url: '/news/generate-ai-summary',
            success: function(ret) {
                $('#ai-news-summary-content').html(ret.summary);
            }
        });
    }

    $('.blind-map').each(function(i, el) {
        var $el = $(el);
        var showMap = $el.data('show-map') != undefined ? $el.data('show-map') : true;
        var showCopy = $el.data('show-copy') != undefined ? $el.data('show-copy') : true;
        var zoomControl = $el.data('zoom-control') != undefined ? $el.data('zoom-control') : false;
        
        var map = L.map($el.attr('id'), {
            zoomControl: zoomControl,
            dragging: false,
            doubleClickZoom: false,
            scrollWheelZoom: false,
            attributionControl: showCopy
        });

        if (showMap) {
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                opacity: 0.25
            }).addTo(map);
        }

        if ($el.data('geojson')) {
            $.getJSON($el.data('geojson'), function(data) {
                if (data) {
                    let poly = L.geoJson(data, {
                        style: {
                            fillColor: '#377dff',
                            color: '#21325b',
                            fillOpacity: 0.2,
                            opacity: 0.75
                        },
                        pointToLayer: function (feature, latLng) {
                            return L.circleMarker(latLng, {
                                radius: 5,
                                fillColor: "#009688",
                                color: "#009688",
                                weight: 10,
                                fillOpacity: 0.9
                            });
                        },
                        onEachFeature: function (feature, layer) {
                            // does this feature have a property named popupContent?
                            if (feature.properties && feature.properties.name) {
                                layer.bindPopup(feature.properties.name);
                            }
                        }
                    }).addTo(map);

                    map.fitBounds(poly.getBounds());
                }
            });
        }
    });

    $('[data-event-category]').on('click', function() {
        var $el = $(this);

        dataLayer.push({
            'event': 'ga_event',
            'eventcategory': $el.data('event-category'),
            'eventaction': $el.data('event-action'),
            'eventlabel': $el.data('event-label')
        });

        console.log(dataLayer, 'dataLayer');
    });

    $('[data-viewable-url]').each(function(i, item) {
        var $item = $(item);
        $.get($item.data('viewable-url'));
    });

    // Auto-submit Jobs Search filters on change.
    // Any input/select inside `form.ajax` triggers a submit; this covers the new
    // top filter bar (checkboxes inside dropdowns, "Posted" radios, sort select)
    // as well as any legacy filter forms that use the same convention.
    $(document).on('change', 'form.ajax input[type="checkbox"], form.ajax input[type="radio"], form.ajax select', function() {
        $(this).closest('form').submit();
    });

    // Keep the filter dropdown menus open while the user toggles checkboxes/radios
    // inside them — Bootstrap closes them by default on any click.
    $(document).on('click', '.js-jobs-filter-form .dropdown-menu', function(e) {
        e.stopPropagation();
    });
});

$.extend({
    HSCore: {
        init: function () {
            $((function () {
                var unfold = new HSUnfold('.js-hs-unfold-invoker').init();
                
                $('.js-counter').each(function() {
                    var counter = new HSCounter($(this)).init();
                });

                $('.js-go-to').each(function () {
                    var goTo = new HSGoTo($(this)).init();
                });
            }));
        },
  
        components: {
            
        }
    }
});

$.HSCore.init();

function initAutocomplete(input, type) {
    const indexes = {
        'business': 'hub_business_query_suggestions',
        'map': 'hub_business_query_suggestions',
        'news': 'hub_news_query_suggestions',
    };
    const client = algoliasearch('HP6HHQEHJ5', '110ee0d909c3c9c7bcbb7fe0e693d890');
    const index = client.initIndex(indexes[type]);
    const MAX_AUTOCOMPLETE_ITEMS = 5;
    let arr = [], currentFocus;

    /* execute a function when someone interacts with the text field */
    input.addEventListener("input", function(e) {
        if (! this.value) {
            return closeAllLists();
        }

        index
            .search(this.value)
            .then(({ hits }) => {
                closeAllLists();

                if (hits.length === 0) {
                    return;
                }

                arr = [];

                for(let i = 0; i < Math.min(MAX_AUTOCOMPLETE_ITEMS, hits.length); i++) {
                    arr.push({
                        highlightedResult: hits[i]['_highlightResult']['query'].value,
                        query: hits[i]['query'],
                    });
                }

                currentFocus = -1;

                /* create a div element that will contain the items (values) */
                let containerItems = document.createElement("div");
                containerItems.setAttribute("id", this.id + "autocomplete-list");
                containerItems.setAttribute("class", "autocomplete-items");

                /* append the DIV element as a child of the autocomplete container */
                this.parentNode.appendChild(containerItems);

                for (let i = 0; i < arr.length; i++) {
                    /* create a div element for each matching element */
                    let containerItem = document.createElement("div");

                    /* make the matching letters bold */
                    containerItem.innerHTML = arr[i]['highlightedResult'].replaceAll('<em>', '<strong>').replaceAll('</em>', '</strong>');

                    /* insert input field that will hold the current array item's value */
                    containerItem.innerHTML += "<input type='hidden' value='" + arr[i]['query'] + "'>";

                    /* execute a function when someone clicks on the item value (div element) */
                    containerItem.addEventListener("click", function(e) {
                        input.value = this.getElementsByTagName("input")[0].value;
                        if (type === 'map') {
                            window.location.href = '/maps?query=' + input.value;
                        } else if (type === 'business') {
                            window.location.href = '/search?query=' + input.value;
                        }
                        closeAllLists();
                    });

                    containerItems.appendChild(containerItem);
                }
            }).catch(() => closeAllLists());
    });

    /* execute a function presses a key on the keyboard: */
    input.addEventListener("keydown", function(e) {
        let el = document.getElementById(this.id + "autocomplete-list");
        if (el) el = el.getElementsByTagName("div");

        if (e.keyCode === 40) { // down
            currentFocus++;
            addActive(el);
        } else if (e.keyCode === 38) { //up
            currentFocus--;
            addActive(el);
        } else if (e.keyCode === 13) { // enter
            if (currentFocus > -1 && el) {
                e.preventDefault();
                el[currentFocus].click();
            }
        }
    });

    function addActive(el) {
        /* a function to classify an item as "active" */
        if (! el) return false;

        /* start by removing the "active" class on all items */
        removeActive(el);

        if (currentFocus >= el.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (el.length - 1);

        el[currentFocus].classList.add("autocomplete-active");
    }

    function removeActive(el) {
        /* a function to remove the "active" class from all autocomplete items */
        for (let i = 0; i < el.length; i++) {
            el[i].classList.remove("autocomplete-active");
        }
    }

    function closeAllLists() {
        let items = document.getElementsByClassName("autocomplete-items");

        for (let i = 0; i < items.length; i++) {
            items[i].parentNode.removeChild(items[i]);
        }
    }

    /* execute a function when someone clicks in the document */
    document.addEventListener("click", function (e) {
        closeAllLists(e.target);
    });
}